import { FormattedMessage, injectIntl } from "react-intl";
import ENV from "../../../../../config";

const RegistrationFormModalFooter = (): JSX.Element => {
  return (
    <div className="registration-form-modal__footer">
      <FormattedMessage
        tagName="span"
        id="registrations-registration-already-have"
      />
      <span
        className="login-link"
        onClick={() => window.location.replace(ENV.MAIN_SITE_URL + "/login")}
      >
        <FormattedMessage tagName="span" id="login-login" />
      </span>
    </div>
  );
};

export default injectIntl(RegistrationFormModalFooter);
